module.exports = __webpack_public_path__ + "img/rule-text.528a0570.svg";